import script from "./AutomationsPageBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomationsPageBanner.vue?vue&type=script&setup=true&lang=js"

import "./AutomationsPageBanner.vue?vue&type=style&index=0&id=23fab940&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fab940"]])

export default __exports__